import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";
import moment from "moment";
import line from "../../../Images/line.jpeg";

var sectionStyle = {
  backgroundImage: `url(${line})`
};

class PatientDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      patient: "",
      homeCarePlanDetails: null,
      medicineDetails: null,
      equipmentDetails: null,
      rehabDetails: null,
      spinnerClass: "",
      dataClass: "collapse"
    };
  }

  componentDidMount() {
    this.LoadDetails();
    this.LoadHomeCarePlan();
    this.LoadMedicine();
    this.LoadEquipment();
    this.LoadRehab();
  }

  LoadDetails() {
    var obj = { pno: this.props.data.pno }
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/details",
        obj
      )
      .then(response => {
        this.setState({
          patient: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  LoadHomeCarePlan() {
    var obj = { pno: this.props.data.pno }
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/homeCarePlan/" + this.props.data.pno.replace("/", "-")
      )
      .then(response => {
        this.setState({
          homeCarePlanDetails: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  LoadMedicine() {
    var obj = { pno: this.props.data.pno }
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/medicine/patientHistory",
        obj
      )
      .then(response => {
        this.setState({
          medicineDetails: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  LoadRehab() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/rehabilitation/" +
        this.props.data.pno.replace("/", "-")
      )
      .then(response => {
        this.setState({
          rehabDetails: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  LoadEquipment() {
    var obj = { eno: "" }
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/equipment/report",
        obj
      )
      .then(response => {
        this.setState({
          equipmentDetails: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <div className="row p-2" style={sectionStyle}>&nbsp;</div>
        <div className="row p-1" style={sectionStyle} >
          <div className="col col-12">
            <h3 align="center">Patient Details [{this.state.patient.name}]</h3></div>
        </div>
        <div className="container-fluid reportFont">
          <div className="row">
            <div className="col col-md-2 border"><h5>Reg No</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.pno}
            </div>
            <div className="col col-md-2 border"><h5>Reg Date</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.DisplayDate(this.state.patient.regdate)}
            </div>
            <div className="col col-md-2 border"><h5>Grade</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.grade}
            </div>
          </div>
          <div className="row">
            <div className="col col-md-2 border"><h5>Age</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.age}
            </div>
            <div className="col col-md-2 border"><h5>Gender</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.DisplayGender(this.state.patient.gender)}
            </div>
            <div className="col col-md-2 border"><h5>Home Care Plan</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.homeCarePlan}
            </div>
          </div>
          <div className="row">
            <div className="col col-md-2 border"><h5>Panjayath</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.panjayath}
            </div>
            <div className="col col-md-2 border"><h5>Ward #</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.wardno}
            </div>
            <div className="col col-md-2 border"><h5>Route</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.route}
            </div>
          </div>
          <div className="row">
            <div className="col col-2 border"><h5>Address</h5></div>
            <div className="col col-6 border" align="left">
              {this.state.patient.address}
            </div>
            <div className="col col-2 border"><h5>Diagnosis</h5></div>
            <div className="col col-2 border" align="left">
              {this.state.patient.diagnosis}
            </div>
          </div>
          <div className="row">
            <div className="col col-md-2 border"><h5>Volunteer</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.volunteer}
            </div>
            <div className="col col-md-2 border"><h5>Phone 1</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.phone1}
            </div>
            <div className="col col-md-2 border"><h5>Phone 2</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.state.patient.phone2}
            </div>
          </div>
          <div className="row">
            <div className="col col-md-2 border"><h5>Exp Date</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.DisplayDate(this.state.patient.expdate)}
            </div>
            <div className="col col-md-2 border"><h5>Dropout Date</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.DisplayDate(this.state.patient.dropdate)}
            </div>
            <div className="col col-md-2 border"><h5>Temp Patient</h5></div>
            <div className="col col-md-2 border" align="left">
              {this.DisplayTemp(this.state.patient.temp)}
            </div>
          </div>

          <div className="row p-1" style={sectionStyle}>&nbsp;</div>
          <div className="row p-1" style={sectionStyle} >
            <div className="col col-12"><h3 align="center">Home Care</h3></div>
          </div>

          <div className="row">
            <div className="col col-md-2 border"><h5>Date</h5></div>
            <div className="col col-md-2 border"><h5>Type</h5></div>
          </div>
          {this.tabHomeCarePlan()}

          <div className="row p-1" style={sectionStyle}>&nbsp;</div>
          <div className="row p-1" style={sectionStyle} >
            <div className="col col-12"><h3 align="center">Medicine</h3></div>
          </div>

          <div className="row">
            <div className="col col-2 border"><h5>Date</h5></div>
            <div className="col col-5 border"><h5>Medicine</h5></div>
            <div className="col col-2 border"><h5>Quantity</h5></div>
          </div>
          {this.tabMedicine()}

          <div className="row p-1" style={sectionStyle}>&nbsp;</div>
          <div className="row p-1" style={sectionStyle} >
            <div className="col col-12"><h3 align="center">Equipment</h3></div>
          </div>

          <div className="row">
            <div className="col col-2 border"><h5>Lend Out Date</h5></div>
            <div className="col col-5 border"><h5>Equipment</h5></div>
            <div className="col col-2 border"><h5>Quantity</h5></div>
            <div className="col col-2 border"><h5>Returned Date</h5></div>
          </div>
          {this.tabEquipment()}

          <div className="row p-1" style={sectionStyle}>&nbsp;</div>
          <div className="row p-1" style={sectionStyle} >
            <div className="col col-12"><h3 align="center">Rehabilitation</h3></div>
          </div>
          <div className="row">
            <div className="col col-2 border"><h5>Date</h5></div>
            <div className="col col-5 border"><h5>Description</h5></div>
            <div className="col col-2 border"><h5>Quantity</h5></div>
          </div>
          {this.tabRehab()}
        </div>

      </div>

    );
  }

  tabHomeCarePlan() {
    if (this.state.homeCarePlanDetails != null) {
      return this.state.homeCarePlanDetails.map((obj) => {
        return (
          <div className="row">
            <div className="col col-md-2 border">{this.DisplayDate(obj.date)}</div>
            <div className="col col-md-2 border">{obj.type}</div>
          </div>
        );
      });
    }
  }

  tabMedicine() {
    if (this.state.medicineDetails != null) {
      return this.state.medicineDetails.map((obj) => {
        return (
          <div className="row">
            <div className="col col-2 border">{this.DisplayDate(obj.txnDate)}</div>
            <div className="col col-5 border">{obj.medName}</div>
            <div className="col col-2 border">{obj.qty}</div>
          </div>
        );
      });
    }
  }

  tabEquipment() {
    if (this.state.equipmentDetails != null) {
      return this.state.equipmentDetails.map((tracker) => {
        let eqName = tracker.name;
        let pno = this.props.data.pno;

        return tracker.tracker.map((obj) => {
          if (pno === obj.pno) {
            return (
              <div className="row">
                <div className="col col-2 border">{this.DisplayDate(obj.outdate)}</div>
                <div className="col col-5 border">{eqName}</div>
                <div className="col col-2 border">{obj.qty}</div>
                <div className="col col-2 border">{this.DisplayDate(obj.indate)}</div>
              </div>
            );
          }
        });
      });
    }
  }

  tabRehab() {
    if (this.state.rehabDetails != null) {
      return this.state.rehabDetails.map((obj) => {
        return (
          <div className="row">
            <div className="col col-2 border">{this.DisplayDate(obj.date)}</div>
            <div className="col col-5 border">{obj.desc}</div>
            <div className="col col-2 border">{obj.qty}</div>
          </div>
        );
      });
    }
  }

  DisplayDate(date) {

    if (date == null || date == "")
      return "";
    else {
      var arrDate = new Date(date).toDateString().split(" ");

      if (parseInt(arrDate[3]) != 1) {
        return (
          arrDate[2] +
          "-" +
          arrDate[1] +
          "-" +
          arrDate[3]
        );
      }
      else {
        return "";
      }

    }
  }

  DisplayMonth(date) {
    if (date == null || date == "")
      return "";
    else {
      return moment(date).format("MMM-YYYY")
    }
  }

  DisplayGender(gender) {
    if (gender == null || gender == "")
      return "";
    else if (gender == "M") {
      return "Male";
    }
    else if (gender == "F") {
      return "Female";
    }
    else if (gender == "T") {
      return "Trans";
    }
  }

  DisplayTemp(temp) {
    if (temp)
      return "Yes";
    else
      return "No";
  }


  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default PatientDetails;
